import { styled } from 'goober';

const ProductCardContainer = styled('div')`
  width: 360px;
  height: 215px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  box-sizing: content-box !important;
  overflow: hidden;
  display: flex;
  background-image: ${(props) =>
    props.imageUrl ? `url(${props.imageUrl})` : 'none'};
  @media screen and (max-width: 800px) {
    width: 220px;
    height: 115px;
  }
`;

const ProductCard = (props) => {
  const { productCardClick, productBackgroundImg } = props;
  return (
    <ProductCardContainer
      onClick={() => {
        productCardClick();
      }}
      imageUrl={productBackgroundImg}
    />
  );
};

export default ProductCard;



// WEBPACK FOOTER //
// ./componentsBICRevamp/productCard/index.js